import React, { useEffect, useState } from "react";
import { useBackButton } from "../../hooks/useBackButton";
import Header from "../../components/Header";
import MyOrders from "../../components/order_components/MyOrders";
import CoursesCard from "../../components/course_components/CoursesCard";
import { useNavigate } from "react-router-dom";
import './Lobby.scss'; // Подключаем стили
import ProductCardEmpty from "../../components/products_components/ProductCardEmpty";
import ProductCard from "../../components/products_components/ProductCard";
import Button from "../../components/ui/Button";
import api from "../../api";
import LoaderBlock from "../../components/ui/LoaderBlock";
import { useBackButtonManager } from '../../contexts/BackButtonContext';

const Lobby = () => {
  const navigate = useNavigate();

  const { action, clear } = useBackButtonManager();
  const [isLoadProducts, setIsLoadProducts] = useState(true);
  const [products, setProducts] = useState([]);
  const [requests, setRequests] = useState([]);
  const [search, setSearch] = useState("");

  const filteredProducts = search.trim()
  ? products.filter((p) =>
      p.name.toLowerCase().includes(search.trim().toLowerCase())
    )
  : products;

  useEffect(() => {
      clear();
      setIsLoadProducts(true);
      const fetchProducts = async () => {
          try {
              const response = await api.get("/api/products/UserProducts");
              const data = response.data;
              setProducts(data.products);
              setRequests(data.requests);
              setIsLoadProducts(false);
          } catch (error) {
              console.error("Ошибка при загрузке товаров:", error);
          }
      };
      fetchProducts();
  }, []);

  return (
    <>
      <Header></Header>
      <div className="courses-section">
        <CoursesCard></CoursesCard>
        <Button onClick={() => { navigate("/request") }} className="btn mt-3 btn-primary large">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 5C12.5523 5 13 5.44772 13 6V11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H13V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V13H6C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11H11V6C11 5.44772 11.4477 5 12 5Z" fill="#1D1D20"/>
</svg>
Добавить товар на просчёт
        </Button>
      </div>

      <div className="orders-section">
        <div className="title-section">Заказы <div onClick={() => {navigate("/orders")}} className="right-all">Все <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.96847 6.90203C10.2987 6.6085 10.8044 6.63824 11.0979 6.96847L15.0979 11.4685C15.3673 11.7716 15.3673 12.2283 15.0979 12.5315L11.0979 17.0315C10.8044 17.3617 10.2987 17.3914 9.96847 17.0979C9.63824 16.8044 9.6085 16.2987 9.90203 15.9685L13.4296 12L9.90203 8.03145C9.6085 7.70122 9.63824 7.19557 9.96847 6.90203Z" fill="white" fill-opacity="0.48"/>
          </svg>
          </div>
        </div>
        <MyOrders />
      </div>
      <div className="catalog-section">
        <div className="title-section big">Просчитанные товары</div>
        <div className="search-input">
          <input
            placeholder="Быстрый поиск"
            disabled={isLoadProducts}
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        {isLoadProducts ? (
          <LoaderBlock minHeight={100} iconSize={32} />
        ) : (
          <div className="categories row g-2">
            {search.trim() === "" &&
              requests.map((request, index) => (
                <div key={`request-${index}`} className="col col-6 mt-3">
                  <ProductCardEmpty id={request.id} />
                </div>
              ))}

            {filteredProducts.map((product, index) => (
              <div key={`product-${index}`} className="col col-6 mt-3">
                <ProductCard
                  id={product.id}
                  image={product.mainImage}
                  cost={product.cost}
                  title={product.name}
                />
              </div>
            ))}

            {filteredProducts.length === 0 && search.trim() !== "" && (
              <div className="col-12 white-text text-center py-4">
                Ничего не найдено по запросу "{search}"
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Lobby;
